import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { Icon } from '@iconify/react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TUser } from '../../shared/types/user.type'
import { toast } from 'react-toastify'
import { t } from 'i18next'
import { Link, useNavigate } from 'react-router-dom'
import { useQueryClient } from 'react-query';

function ConnectedAsBanner({ open }: { open: boolean }) {
    const user = useSelector<RootState>(state => state.user.user) as TUser
    const QueryClient = useQueryClient()
    const adminJwt = localStorage.getItem('adminToken')
    const navigate = useNavigate()

    const copyPageWithToken = () => {
        let link = window.location.href
        let token = localStorage.getItem('token')

        navigator.clipboard.writeText(link.concat(`${link.includes('?') ? '&' : '?'}jwt=${token}`))
        toast('Link copied to clipboard', { type: 'success' })
    }


    const updateToken = () => {

        if (adminJwt) {
            //We swap the token
            localStorage.setItem('token', adminJwt)
            localStorage.removeItem('adminToken')
            QueryClient.refetchQueries(['auth'])
            navigate('/')
        }



    }

    return (
        <Box bgcolor={'#2196f3'} py={0.5} width={'100%'} gap={1} px={1} display={'flex'} flexDirection={{ md: 'row', xs: 'column' }} alignItems={'center'} justifyContent={'space-between'}>
            <Typography color={'white'} variant='body2' alignItems={'center'} display={'flex'} gap={1}>
                <Icon icon='fluent:plug-connected-20-regular' width={20} height={20}></Icon>
                Logged in as {user?.email}</Typography>

            <Box gap={1} display={'flex'}>

                {
                    adminJwt && <Button onClick={updateToken} size='small' sx={{ color: 'white', alignSelf: 'center' }} startIcon={<Icon icon='fluent-mdl2:switch-user' width={20} height={20}></Icon>}>Switch to my account</Button>
                }
                <Button size='small' component={Link} to={process.env.REACT_APP_BACKOFFICE_URI ?? ""} target='_blank' sx={{ color: 'white', alignSelf: 'center' }} startIcon={<Icon icon='material-symbols:admin-panel-settings-rounded' width={20} height={20}></Icon>}>Backoffice</Button>
                <Button size='small' onClick={copyPageWithToken} sx={{ color: 'white', alignSelf: 'center' }} startIcon={<Icon icon='icon-park-outline:copy-link' width={20} height={20}></Icon>}>Copy page link</Button>
            </Box>
        </Box>
    )
}

export default ConnectedAsBanner